import { Injectable } from '@angular/core';
import { AppApiService } from 'src/app/app-api.service';

@Injectable({
  providedIn: 'root'
})
export class HistoryCommitteesMembersService extends AppApiService {
  public url: string | null = 'cesew/historyCommitteesMembers';
}
